import { FunctionComponent, useRef, useEffect } from "react";
import styled from "styled-components";
import Column from "../../../components/Column";
import PostsFeed from "../components/posts/PostsFeed";

interface IPostsSectionProps {}

const PostsSection: FunctionComponent<IPostsSectionProps> = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  // Check if we're coming from a different section BEFORE rendering PostsFeed
  const lastSection = sessionStorage.getItem('lastSection');
  const currentSection = 'posts';
  
  // If lastSection is different from current, clear localStorage (navigation from other section)
  // If lastSection is same as current, keep localStorage (refresh within posts section)
  if (lastSection && lastSection !== currentSection) {
    localStorage.removeItem('postsSection_showManageFeeds');
    localStorage.removeItem('postsSection_showConnections');
    localStorage.removeItem('postsSection_selectedFeedId');
  }

  useEffect(() => {
    // Update current section after render
    sessionStorage.setItem('lastSection', currentSection);
  }, []); // Only run on mount

  return (
    <Container ref={containerRef}>
      <Column gap="20px">
        <PostsFeed containerRef={containerRef} />
      </Column>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  padding: 0px 16px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100vh;
  overflow-y: scroll;
  scrollbar-gutter: stable;
`;

export default PostsSection;
